import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import AddIcon from '@mui/icons-material/Add';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import Search from 'src/components/View/Header/Search';
import SelectStatus from 'src/components/View/Header/SelectStatus';
import ButtonInner from 'src/components/View/Header/ButtonInner';
import { TEMPLATE_CONTEXT_SCOPE_OPTIONS } from 'src/constants/templateContextScope';
import helpers from 'src/helpers';
import {
  setCurrentMessage,
  setIsModalVisible,
  getUserMessageCode,
  setImportPBTemplatesModalVisible,
} from 'src/actions/messagesActions';

import searchBoxStyle from 'src/views/Settings/MessageView/searchBox.style';

const useStyles = makeStyles()(searchBoxStyle);

function SearchBox({
  query,
  setSearch,
  onSearch,
  loading,
  onChangeContextScope = () => { },
}) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { search, contextScope = '' } = query || {};
  const { user, pbAPIKeyValid } = useSelector((state) => state?.account || {});
  const { userMessagingSystem } = user || {};
  const { apiKey } = userMessagingSystem || {};

  const showImportPBTemplates = !helpers.isEmpty(apiKey) && pbAPIKeyValid;

  const handleClearSearch = () => {
    setSearch('');
    onSearch();
  };

  const handleClickAddTemplate = useCallback(() => {
    dispatch(setIsModalVisible());
    dispatch(getUserMessageCode());
    dispatch(setCurrentMessage({ addNewTemplate: true }));
  }, [dispatch]);

  const handleClickImportPBTemplates = useCallback(() => {
    dispatch(setImportPBTemplatesModalVisible(true));
  }, [dispatch]);

  return (
    <>
      <Search
        search={search}
        setSearch={setSearch}
        onSearch={onSearch}
        onClear={handleClearSearch}
      />
      {/* CON-1621 — filter by where a template can be used. Default is All:
          a management screen must show everything. */}
      <SelectStatus
        options={TEMPLATE_CONTEXT_SCOPE_OPTIONS}
        onChange={(option) => onChangeContextScope(option?.value ?? '')}
        selectedValue={contextScope}
        defaultTitle="All Scopes"
        showSelectedDot
      />
      <ButtonInner>
        <Button
          className={classes.buttonAdd}
          variant="contained"
          onClick={handleClickAddTemplate}
          disabled={!!loading}
        >
          <AddIcon />
          Add Template
        </Button>
      </ButtonInner>
      {showImportPBTemplates && (
        <ButtonInner className="large-lg-up">
          <Button
            className={classes.buttonAdd}
            variant="contained"
            onClick={handleClickImportPBTemplates}
            disabled={!!loading}
          >
            <ImportExportIcon />
            Import PB Templates
          </Button>
        </ButtonInner>
      )}
    </>
  );
}

SearchBox.propTypes = {
  query: PropTypes.object.isRequired,
  setSearch: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onChangeContextScope: PropTypes.func,
};

export default SearchBox;
